<div class="d-flex flex-column w-100 bg-white" *ngIf="orderInboxModel">
	<div
		class="d-flex align-items-center justify-content-between w-100 flex-shrink-0 border-bottom px-4 py-3 ci-subheader-order-info"
	>
		<cv-order-info [orderInboxModel]="orderInboxModel" [orderUsers]="orderUsers"></cv-order-info>
	</div>

	<div class="d-flex align-items-center justify-content-between w-100 flex-shrink-0 px-4 ci-subheader-toolbar">
		<div class="d-flex align-items-center gap-3">
			<button
				type="button"
				class="btn btn-sm d-inline-flex align-items-center justify-content-center gap-2 border bg-white text-nowrap"
				(click)="openOrderActivity()"
			>
				<i class="fa-regular fa-clock"></i>
				<span>Activity</span>
			</button>
			<span
				class="flex-shrink-0 align-self-center border-start ci-subheader-separator"
				*ngIf="isCmpAcuityOrder"
			></span>
			<cv-historical-order-details-button
				*ngIf="isCmpAcuityOrder"
				[orderDetail]="orderInboxModel"
			></cv-historical-order-details-button>
			<span
				class="flex-shrink-0 align-self-center border-start ci-subheader-separator"
				*ngIf="downloadButtons.isAvailable"
			></span>
			<cv-download-buttons #downloadButtons [orderInboxModel]="orderInboxModel"></cv-download-buttons>
			<span class="flex-shrink-0 align-self-center border-start ci-subheader-separator"></span>
			<button
				type="button"
				class="btn btn-sm d-inline-flex align-items-center justify-content-center border bg-white px-2 ci-subheader-icon-btn"
				[class.bg-light]="isSidebarOpen"
				tooltipStyleClass="custom-tooltip"
				tooltipPosition="top"
				[pTooltip]="isSidebarOpen ? 'Hide Checklist' : 'Show Checklist'"
				(click)="toggleSidebar()"
			>
				<i class="fa-regular fa-sidebar"></i>
			</button>
			<cv-ci-sub-header-lock-button [orderInboxModel]="orderInboxModel"></cv-ci-sub-header-lock-button>
		</div>

		<div class="d-flex align-items-center gap-3 ms-auto">
			<cv-ucdp-details-button [orderDetail]="orderInboxModel"></cv-ucdp-details-button>
			<span class="flex-shrink-0 align-self-center border-start ci-subheader-separator"></span>
			<cv-not-reviewed *ngIf="isManualOrder"></cv-not-reviewed>
			<span
				*ngIf="isManualOrder"
				class="flex-shrink-0 align-self-center border-start ci-subheader-separator"
			></span>
			<cv-approve-reject-buttons></cv-approve-reject-buttons>
		</div>
	</div>
</div>
